import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ApiService from "../nhrc_apis/ApiService";
const {EventAPI}=ApiService;

const GlobalNetworks = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const editEvent = location.state?.job || null;

  const [showPreview, setShowPreview] = useState(false);

  const [formData, setFormData] = useState({
    eventTitle: "",
    mode: "",
    category: "",
    organizer: "",
    speaker: "",
    banner: null,
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    location: "",
  });

  /* ===== LOAD EDIT DATA ===== */
  useEffect(() => {
    if (editEvent) {
      setFormData({
        eventTitle: editEvent.title || "",
        mode: editEvent.eventmode || "",
        category: editEvent.programcategory || "",
        organizer: editEvent.organizername || "",
        speaker: editEvent.speakername || "",
        banner: editEvent.banner || null,
        startDate: editEvent.startDate || "",
        endDate: editEvent.endDate || "",
        startTime: editEvent.startTime || "",
        endTime: editEvent.endTime || "",
        location: editEvent.location || "",
      });
    }
  }, [editEvent]);

  /* ===== INPUT HANDLER ===== */
  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      const file = files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prev) => ({
          ...prev,
          banner: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };



const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const payload = {
      service_id: 6,
      title: formData.eventTitle,
      program_category: formData.category,
      organizer_name: formData.organizer,
      speaker_name: formData.speaker,
      event_mode: formData.mode,
      start_date: formData.startDate,
      end_date: formData.endDate,
      start_time: formData.startTime,
      end_time: formData.endTime,
      location: formData.location,
      description: formData.category,
      banner_image: formData.banner,
    };

    const response =
      await EventAPI.createEvents(payload);

    console.log(
      "EVENT CREATED:",
      response.data
    );

    toast.success(
      "Event Created Successfully",
      {
        position: "top-center",
        autoClose: 2000,
      }
    );

    setTimeout(() => {
      navigate("/dashboard/GnTotalApplications");
    }, 1500);

  } catch (error) {

    console.error(
      "CREATE EVENT ERROR:",
      error
    );

    toast.error(
      error?.response?.data?.message ||
      "Failed To Create Event"
    );
  }
};

  return (
    <div className="container mt-4 mb-5">
      <h4 className="mb-4 text-danger fw-bold text-center">
        NHRC - Global Networking (Admin)
      </h4>

      <form
        className="p-3 border rounded shadow-sm bg-white"
        onSubmit={handleSubmit}
      >
        {/* TITLE + MODE */}
        <div className="d-flex gap-4">
          <div className="mb-3 w-50">
            <label className="form-label">Event Title*</label>
            <input
              className="form-control"
              name="eventTitle"
              value={formData.eventTitle}
              onChange={handleChange}
              required
            />
          </div>

          <div className="w-50">
            <label className="form-label">Event Mode*</label>
            {["Inperson", "Virtual", "Hybrid"].map((m) => (
              <div key={m} className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  name="mode"
                  value={m}
                  checked={formData.mode === m}
                  onChange={handleChange}
                />
                <label className="form-label">{m}</label>
              </div>
            ))}
          </div>
        </div>

        {/* CATEGORY + ORGANIZER */}
        <div className="d-flex gap-4">
          <div className="mb-3 w-50">
            <label className="form-label">Program Category*</label>
            <select
              className="form-select"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option>Global Networking</option>
              {/* <option>Career Development</option>
              <option>Soft Skills Training</option>
              <option>Technical Skills</option>
              <option>Leadership</option> */}
            </select>
          </div>

          <div className="mb-3 w-50">
            <label className="form-label">Organizer Name*</label>
            <input
              className="form-control"
              name="organizer"
              value={formData.organizer}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* SPEAKER + BANNER */}
        <div className="d-flex gap-4">
          <div className="mb-3 w-50">
            <label className="form-label">Speaker Name</label>
            <input
              className="form-control"
              name="speaker"
              value={formData.speaker}
              onChange={handleChange}
            />
          </div>

          <div className="w-50">
            <label className="form-label">Upload Cover Image</label>
            <input
              type="file"
              className="form-control"
              onChange={handleChange}
            />
            {formData.banner && (
              <button
                type="button"
                onClick={() => setShowPreview(true)}
                className="btn btn-link p-0 mt-1"
              >
                View Banner
              </button>
            )}
          </div>
        </div>

        {/* DATES */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Date*</label>
            <input
              type="date"
              className="form-control"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">End Date*</label>
            <input
              type="date"
              className="form-control"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* TIME */}
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Start Time*</label>
            <input
              type="time"
              className="form-control"
              name="startTime"
              value={formData.startTime}
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">End Time*</label>
            <input
              type="time"
              className="form-control"
              name="endTime"
              value={formData.endTime}
              onChange={handleChange}
              required
            />
          </div>
        </div>
  
        {/* LOCATION */}
        <div className="mb-3">
          <label className="form-label">Location*</label>
          <input
            className="form-control"
            name="location"
            value={formData.location}
            onChange={handleChange}
            required
          />
        </div>

        <button
          type="button"
          className="btn btn-secondary me-3"
          onClick={() => navigate(-1)}
        >
          Back
        </button>

        <button type="submit" className="btn btn-success">
          {editEvent ? "Update Event" : "Submit"}
        </button>
      </form>

      {/* PREVIEW MODAL */}
      {showPreview && (
        <div
          onClick={() => setShowPreview(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: "#fff", padding: 20, borderRadius: 8 }}>
            <img
              src={formData.banner}
              alt="Banner Preview"
              style={{ maxWidth: "600px", maxHeight: "400px" }}
            />
            <div className="text-end mt-2">
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => setShowPreview(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default GlobalNetworks;
